module.exports = {"classifyName":"","title":"","backgroundColor":"#D9E8F8","shareTitle":"","shareContent":"","shareImg":"","navigatorBarTranslucent":"是","searchBoxDisplay":"否","navigatorBarTheme":"白","componentDivideLine":"http://static.shihuocdn.cn/admin/files/20210328/7ad74522a856ff02091145d64341635a.png","abTestEnable":"否","abPreviewValue":"A","abPercent":50,"createTime":""}


//////////////////
// WEBPACK FOOTER
// ./templates/luodiye/src/config/base-config-test.json
// module id = 367
// module chunks = 0